import { filter } from 'lodash';
import PropTypes from 'prop-types';
import { sentenceCase } from 'change-case';
import { useEffect, useState, useRef, useCallback } from 'react';
import faker from 'faker';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  Container,
  Dialog,
  DialogTitle,
  Typography,
  DialogActions,
  DialogContent,
  DialogContentText,
  TableContainer,
  tableCellClasses
} from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { setApiError } from '../../store/Slice/Error/ErrorSlice';
import { JourneyApi } from '../../utils/Apis';
import useJourneySelector from '../../store/Slice/Journey/JourneySelector';

// components
import { getJourneysList } from '../../store/Slice/Journey/JourneySlice';
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user';
import BrudCrumbs from '../../components/BreadCrumbs';
import { getIcon, JourneyIcon } from '../../vector/index';
import PageTitle from '../../components/PageHeading';
import { fDate } from '../../utils/formatTime';

import Loader from '../Global/Loader';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

// styling
import JourneyToolbar from './JourneyToolbar';
import ApiErrorMessage from '../Global/ApiErrorMessage';

import JourneyService from '../services/JourneyService';
import { saveApiData } from '../../store/Slice/Global/GlobalSlice';
import { StyledTableCell, StyledTableRow } from '../../utils/StyleTable';

const { SaveJourneyTemplate } = JourneyService;

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'id', label: 'Journey ID', alignRight: false },
  { id: 'journeyName', label: 'Journey Name', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'loanSubType', label: 'Loan Sub Type', alignRight: false },
  { id: 'employmentType', label: 'Employment Type', alignRight: false },
  { id: 'employmentSubType', label: 'Employment Sub Type', alignRight: false },
  { id: 'statusCallCenter', label: 'Status', alignRight: false },
  { id: 'active', label: 'Publish', alignRight: false },
  { id: 'createdOn', label: 'Created On', alignRight: false },
  { id: 'modifiedOn', label: 'Modified On', alignRight: false },
  { id: '', label: 'ACTION' }
];

localStorage.setItem('pageCount', 1);
const pageNo = localStorage.getItem('pageCount');
export default function Journey() {
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(500);
  const [apiSuccessMsg, setApiSuccessMsg] = useState({
    open: false,
    title: null,
    message: null,
    status: null
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [templateName, setTemplateName] = useState('');
  const [saveTemplate, setSaveTemplate] = useState(false);

  const dispatch = useDispatch();
  const { JourneyListData } = useJourneySelector();
  const { LoginData } = useLoginSelector();

  const handleSaveTemplate = async (e, selected, setSelected) => {
    const journeyId = [];
    if (selected.length > 0) {
      selected.forEach((item, index) => {
        journeyId.push(item.journeyId);
      });
    }
    if (templateName === '') {
      setErrorMessage('Please add template name');
      return;
    }
    const credential = {
      companyId: LoginData?.companyId,
      journeyIds: journeyId,
      userId: LoginData?.userId,
      userProvidedtemplateName: templateName
    };
    const SaveJourneyTemplateApi = await dispatch(saveApiData(JourneyApi.journeySave, credential));
    if (SaveJourneyTemplateApi.status === 'success') {
      setSaveTemplate(false);
      dispatch(setApiError('Journey(s) saved as template(s) successfully'));
      // navigate(`/${parent}/add`);
    } else {
      dispatch(setApiError('Unable to save journey(s) as template'));
    }
    setTemplateName('');
    setSelected([]);
  };

  const getJourneyListApi = useCallback(() => {
    setApiSuccessMsg({
      open: false,
      title: null,
      message: null,
      status: null
    });

    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      entityListRequestModel: {
        pageNumber: pageNo,
        pageSize: rowsPerPage,
        searchLiteral: filterName,
        sortOrder: order
      }
    };
    dispatch(getJourneysList(credentials));
  }, [filterName]);

  const loantyprapiFire = async (type, condition) => {
    setApiSuccessMsg({
      open: false,
      title: null,
      message: null,
      status: null
    });

    const credientials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      journeyId: condition
    };
    if (type === 'Publish') {
      const res = await dispatch(saveApiData(JourneyApi.journeyPublish, credientials));
      if (res.status === 'success') {
        setApiSuccessMsg({
          open: true,
          title: type,
          message: 'Journey Published Successfully',
          status: null
        });
      }
    } else if (type === 'Delete') {
      const res = await dispatch(saveApiData(JourneyApi.journeyDelete, credientials));
      if (res.status === 'success') {
        setApiSuccessMsg({
          open: true,
          title: type,
          message: 'Journey Deleted Successfully',
          status: null
        });
      }
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = JourneyListData.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handlePublish = (type, journeyId) => {
    setApiSuccessMsg({
      open: true,
      title: type,
      message: `Are You Sure! You Want to ${type} this Journey?`,
      status: journeyId
    });
  };

  const closePopUp = () => {
    setApiSuccessMsg({ open: false, title: null, message: null, status: null });
  };

  const fireApi = () => {
    loantyprapiFire(apiSuccessMsg.title, apiSuccessMsg.status);
  };

  const loadAllData = () => {
    setApiSuccessMsg({ open: false, title: null, message: null, status: null });
    getJourneyListApi();
  };

  useEffect(() => {
    getJourneyListApi();
  }, [getJourneyListApi]);

  return (
    <Page title="Partner Managemet System || Journey">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="List of Journey" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Card>
            <JourneyToolbar
              filterName={filterName}
              onFilterName={handleFilterByName}
              parent="journey"
              selected={selected}
              setSelected={setSelected}
              handleSaveTemplate={handleSaveTemplate}
              templateName={templateName}
              setTemplateName={setTemplateName}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              saveTemplate={saveTemplate}
              setSaveTemplate={setSaveTemplate}
            />

            <Scrollbar>
              <TableContainer
                id="journeyListBox"
                sx={{ minWidth: 800, height: '70vh', overflow: 'auto' }}
                // onScroll={handleScroll}
              >
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={JourneyListData.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    isCheckBox="true"
                  />
                  <TableBody>
                    {JourneyListData.map((item, index) => {
                      const isItemSelected = selected.indexOf(item) !== -1;
                      return (
                        <StyledTableRow
                          hover
                          key={index}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, item)}
                            />
                          </TableCell>

                          <StyledTableCell align="left">
                            {' '}
                            {item.journeyId ? item.journeyId : 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {item.journeyName ? item.journeyName : 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {item.loanType ? item.loanType : 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {item.loanSubType ? item.loanSubType : 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {item.employmentType ? item.employmentType : 'N/A'}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {item.employmentSubType ? item.employmentSubType : 'N/A'}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {item.journeyStatus ? item.journeyStatus : 'N/A'}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {item.journeyPublished ? item.journeyPublished : 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {item.journeyCreatedOn ? fDate(item.journeyCreatedOn) : 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {item.journeyModifiedOn ? fDate(item.journeyModifiedOn) : 'N/A'}
                          </StyledTableCell>

                          <StyledTableCell align="" width={160}>
                            <UserMoreMenu
                              rowId={item}
                              parent="journey"
                              handlePublish={handlePublish}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                  {JourneyListData.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <StyledTableCell align="center" colSpan={12} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
        </Box>
        <Dialog fullWidth className="PopupBox" open={apiSuccessMsg.open} onClose={closePopUp}>
          <DialogTitle className="popupTitle">
            <Typography variant="h6">{apiSuccessMsg.title} Journey</Typography>
            <IconButton onClick={() => closePopUp(0)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography>{apiSuccessMsg.message}</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => (apiSuccessMsg.status !== null ? fireApi() : loadAllData())}
              variant="contained"
              className={apiSuccessMsg.title === 'Delete' ? `mainBtn deleteBtn` : `mainBtn`}
            >
              {apiSuccessMsg.status !== null ? 'Confirm' : 'Ok'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
